__turbopack_context__.v({
  "actionBar": "NMSurveyCard-module__0tX0HW__actionBar",
  "baseInfo": "NMSurveyCard-module__0tX0HW__baseInfo",
  "box": "NMSurveyCard-module__0tX0HW__box",
  "card": "NMSurveyCard-module__0tX0HW__card",
  "icon": "NMSurveyCard-module__0tX0HW__icon",
  "infoStack": "NMSurveyCard-module__0tX0HW__infoStack",
  "title": "NMSurveyCard-module__0tX0HW__title",
});
